import React, { useEffect, useState } from "react";
import { requestAuth } from "../../http/httpRequest";
import { toastOn } from "../../store/slices/toast";
import { Link } from "react-router-dom";
import { NoteIconSvg } from "../../utils/styleFormat";
import { Accordion } from "flowbite-react";

const ListCuadernosAbiertosPanel = ({ rols = [], dispatch }) => {
  const [generalData, setGeneralData] = useState({
    Cuadernos: [],
    loading: "loading",
    datos_rapidos: [],
  });

  const getCuadernosAbiertos = async () => {
    try {
      const response = await requestAuth("get", `/cuadernos/estado/true`, null);
      setGeneralData({
        Cuadernos: response.data.mappedData || [],
        datos_rapidos: response.data.datos_rapidos || [],
        loading: "loaded",
      });
    } catch (error) {
      setGeneralData((x) => ({ ...x, loading: "loaded" }));
      dispatch(
        toastOn({
          type: "danger",
          message:
            error?.response?.data?.message || "Error a listar las casillas.",
        })
      );
    }
  };

  useEffect(() => {
    getCuadernosAbiertos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="my-4">
        <h1 className="dark:text-white font-semibold text-md">
          Cuadernos abiertos
        </h1>
      </div>

      <div className="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 mb-4">
        {generalData.loading === "loading" ? (
          <div className="text-sm dark:text-gray-500">Cargando...</div>
        ) : generalData?.Cuadernos.length > 0 ? (
          generalData?.Cuadernos.map((cuaderno, index) => (
            <Link
              key={index}
              className={`relative flex justify-center transition ease-in-out border-t-8 border-yellow-500 dark:border-yellow-600 rounded-lg bg-white dark:bg-gray-800 dark:hover:bg-gray-700 hover:bg-gray-100 dark:hover:border-red-700 hover:border-red-500 text-gray-800 dark:text-gray-300`}
              to={`rol/ventas/menu/cuadernos/historial/${cuaderno.id}/ventas`}
            >
              <div className="flex flex-col items-center py-4 px-3 gap-2 text-center">
                <span className="absolute">
                  <NoteIconSvg />
                </span>
                <h5 className="mt-[92px] text-md font-bold bg-yellow-500 dark:text-gray-800 rounded-lg px-1">
                  {cuaderno.codigo}
                </h5>
                {/* <i className='far fa-file-lines text-[80px] text-gray-600 dark:text-gray-300'></i> */}
                <span className="mt-1 text-md font-semibold">
                  {cuaderno.nombre_completo}
                </span>
                {/* <span className='text-md font-semibold'>{cuaderno.roles}</span> */}
              </div>
            </Link>
          ))
        ) : (
          <div className="text-gray-700 italic">
            Todos los cuadernos estan cerrados!
          </div>
        )}
      </div>

      {generalData.datos_rapidos.length > 0 && (
        <Accordion collapseAll={true} alwaysOpen={true} className="mb-4 mt-4">
          {Object.entries(
            generalData.datos_rapidos.reduce((acc, item) => {
              if (!acc[item.vendedor]) acc[item.vendedor] = [];
              acc[item.vendedor].push(item);
              return acc;
            }, {})
          ).map(([vendedor, items], idx) => (
            <Accordion.Panel key={idx}>
              <Accordion.Title
                style={{ backgroundColor: "#e8b207", color: "black" }}
              >
                Vendedor: {vendedor}
              </Accordion.Title>
              <Accordion.Content style={{padding: 10}}>
                <div className="bg-white dark:bg-gray-800 rounded-md">
                  <div className="overflow-x-auto">
                    <table className="min-w-full text-left text-sm dark:text-gray-300">
                      <thead>
                        <tr className="border-b border-gray-200 dark:border-gray-700">
                          <th className="px-4 py-2">Cuaderno</th>
                          <th className="px-4 py-2">Cliente</th>
                          <th className="px-4 py-2">Sin Saldo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, index) => (
                          <tr
                            key={index}
                            className="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700"
                          >
                            <td className="px-4 py-2">
                              <Link
                                key={index}
                                to={`rol/ventas/menu/cuadernos/historial/${item.cuaderno_id}/ventas`}
                              >
                                <span className="text-blue-600 hover:underline">
                                  {item.cuaderno}
                                </span>
                              </Link>
                            </td>
                            <td className="px-4 py-2">
                              {item.cliente?.nombre} <br />{" "}
                              {item.cliente?.telefono}{" "}
                              {item.cliente?.geolocalizacion ? (
                                <a
                                  href={`https://www.google.com/maps?q=${item.cliente.geolocalizacion}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-600 hover:underline"
                                >
                                  Ver en Maps
                                </a>
                              ) : (
                                ""
                              )}
                            </td>

                            <td className="px-4 py-2">
                              {item.check ? "✔️" : "❌"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Accordion.Content>
            </Accordion.Panel>
          ))}
        </Accordion>
      )}
    </>
  );
};

export default ListCuadernosAbiertosPanel;
